import React from "react";
import "./AboutList.scss";
import { withRouter } from 'react-router-dom';
import dictionary from "i18next";

const AboutList = (props, onClick) => {
    let aboutList = props.aboutListData;
    let mobile = props.mobile
    return (
        <ul className="about-list">
            {aboutList.map((eachdata, index) => {
                let { fields, displayName } = eachdata;
                let titleParent = displayName;
                // console.log(dictionary.t(titleParent,titleParent));

                let CTA_LinkParent =
                    fields && fields["CTA link"] && fields["CTA link"].value.href
                        ? fields["CTA link"].value.href
                        : "javascript:void(0)";
                return (
                    <li key={index}
                        className={
                            (props.location.pathname.indexOf(CTA_LinkParent) > -1 ||
                                (props.location.pathname.indexOf("press-centre") > -1
                                    && CTA_LinkParent.indexOf('press-centre') > -1))
                                ? "active"
                                : null
                        }
                        id={ mobile ? `m${index}` : index} onClick={()=>{mobile ? document.getElementById(`m${index}`).classList.add("active") : document.getElementById(index).classList.add("active")}}
                    >
                        <a onClick={()=>{mobile ? document.getElementById(`m${index}`).classList.add("active") : document.getElementById(index).classList.add("active")}}   href={CTA_LinkParent}  >{titleParent}</a>
                        <div className="list-item-content1">
                            <ul>
                                {eachdata.items
                                    ? eachdata.items.map((eachItem, indexItem) => {
                                        let { fields, displayName } = eachItem;
                                        let titleChild = displayName

                                        let CTA_LinkChild =
                                            fields &&
                                                fields["CTA link"] &&
                                                fields["CTA link"].value.href
                                                ? fields["CTA link"].value.href
                                                : "javascript:void(0)";
                                        let target =
                                            fields &&
                                                fields["CTA link"] &&
                                                fields["CTA link"].value.target
                                                ? fields["CTA link"].value.target
                                                : "";
                                        return (
                                            <li key={indexItem}
                                                className={
                                                    (props.location.pathname.indexOf(CTA_LinkChild) > -1 || CTA_LinkChild.indexOf('press-releases') > -1)
                                                        ? "active"
                                                        : null
                                                }
                                            >
                                                <a href={CTA_LinkChild} target={target}>{titleChild}</a>
                                                <div className="list-item-content2">
                                                    <ul>
                                                        {eachItem.items
                                                            ? eachItem.items.map(eachinfo => {
                                                                let { fields, displayName } = eachinfo;
                                                                let titleSuperChild = displayName

                                                                let CTA_LinkSuperChild =
                                                                    fields &&
                                                                        fields["CTA link"] &&
                                                                        fields["CTA link"].value.href
                                                                        ? fields["CTA link"].value.href
                                                                        : "javascript:void(0)";

                                                                return (
                                                                    <li className={
                                                                        props.location.pathname.indexOf(CTA_LinkSuperChild) > -1
                                                                            ? "active"
                                                                            : null
                                                                    }>
                                                                        <a href={CTA_LinkSuperChild}>
                                                                            {titleSuperChild}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            })
                                                            : ""}
                                                    </ul>
                                                </div>
                                            </li>
                                        );
                                    })
                                    : ""}
                            </ul>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

export default withRouter(AboutList);
